/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getActiveSearchResult__anchor
 */
export default function getActiveSearchResult() {
  return window.documentViewer.getActiveSearchResult();
}
